<template>
    <div>
        <v-card flat elevation="5">
            <v-container fluid>
                <v-toolbar flat height="40" color="white" dense class="elevation-5 mb-2">
                    <v-toolbar-title class="title">
                        GED
                        <v-chip
                            label
                            larger
                            small
                            class="white--text"
                            color="blue darken-2"
                        >
                            {{ total }}
                        </v-chip>
                    </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical/>
                    <v-btn
                        v-if="!module"
                        depressed
                        class="mr-3 white--text"
                        color="red"
                        small
                        @click="initFolder"
                    >
                        {{ $t('common.clear_filter') }}
                        <v-icon right dark>mdi-trash-can</v-icon>
                    </v-btn>
                    <template v-for="(item, index) in fullPath">
                        <a
                            :key="`n-${index}`"
                            @click="selectFolder(item.id)"
                            style="cursor:pointer;"
                        >
                            <strong>{{ item.name }}</strong>
                        </a>
                        <v-icon
                            v-if="index < fullPath.length - 1"
                            :key="`ic-${index}`"
                            right
                            left
                        >
                            mdi-arrow-right-thin
                        </v-icon>
                    </template>
                    <div class="flex-grow-1"></div>
                    <v-btn
                        :loading="loading"
                        depressed
                        class="ma-2 white--text"
                        color="primary"
                        small
                        @click="findAll"
                    >
                        {{ $t("common.reload") }}
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="addDocumentAction"
                        depressed
                        class="ma-2 white--text"
                        color="teal"
                        small
                        @click="openFormDialog(false, false, true, false, false, {})"
                    >
                        Télécharger
                        <v-icon right dark>mdi-progress-upload</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="module"
                        depressed
                        class="ma-2 white--text"
                        color="teal"
                        outlined
                        small
                        @click="getBack"
                    >
                        {{ $t("common.close") }}
                        <v-icon right dark>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider/>
                <v-row dense>
                    <v-col cols="2" v-if="!module">
                        <v-tabs
                            v-model="tab"
                            centered
                            class="elevation-10"
                            icons-and-text
                        >
                            <v-tabs-slider></v-tabs-slider>

                            <v-tab href="#tab-1">
                                Dossiers
                                <v-icon>mdi-sitemap</v-icon>
                            </v-tab>
                            <v-tab href="#tab-2">
                                Filtre
                                <v-icon>mdi-filter-cog</v-icon>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item value="tab-1">
                                <v-card
                                    class="mx-auto mt-1"
                                    min-width="300"
                                    tile
                                >
                                    <v-system-bar color="amber">
                                        <strong>Main Sections</strong>
                                    </v-system-bar>
                                    <v-divider/>
                                    <v-list dense>
                                        <v-list-item @click="openFormDialog(true, false, true, false, false, {})">
                                            <v-list-item-action>
                                                <v-icon color="red">mdi-shape-square-rounded-plus</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-title class="red--text">Crée Nouvelle Section</v-list-item-title>
                                        </v-list-item>
                                        <v-divider/>
                                        <v-list-item
                                            v-if="addFolderAction"
                                            @click="openFormDialog(false, true, true, false, false, {})"
                                        >
                                            <v-list-item-action>
                                                <v-icon color="teal">mdi-folder-plus</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-title class="teal--text">Crée Nouvelle Dossier</v-list-item-title>
                                        </v-list-item>
                                        <v-divider v-if="addFolderAction"/>
                                    </v-list>
                                    <SectionTreeview
                                        v-model="parentId"
                                        @select="selectFolder"
                                        @onDragStart="onDragStart"
                                        @onDrop="onDrop"
                                    />

                                </v-card>
                            </v-tab-item>
                            <v-tab-item value="tab-2">
                                <v-card
                                    class="mx-auto mt-1"
                                    tile
                                >
                                    <v-container fluid>
                                        <w-fieldset title="Recherche Sémantique">
                                            <v-container fluid>
                                                <v-form ref="searchForm" lazy-validation>
                                                    <v-row dense>
                                                        <v-col cols="12">
                                                            <w-text-field v-model="search"/>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-btn
                                                                depressed
                                                                small
                                                                class="white--text"
                                                                color="teal"
                                                                block
                                                                @click="getSemanticSearch"
                                                            >
                                                                Rechercher
                                                                <v-icon right>mdi-magnify</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </v-container>
                                        </w-fieldset>
                                        <br/>
                                        <w-fieldset>
                                            <v-container fluid>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <strong>Nom</strong>
                                                        <w-text-field v-model="filter.name"/>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <strong>Nom Fichier</strong>
                                                        <w-text-field v-model="filter.fileName"/>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <strong>Numéro</strong>
                                                        <w-text-field v-model="filter.number"/>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <strong>Tags</strong>
                                                        <w-data-select-autocomplete
                                                            v-model="filter.tagIds"
                                                            multiple
                                                            type="EDMS_TAG"
                                                        />
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <strong>Du</strong>
                                                        <w-date-picker v-model="filter.start"/>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <strong>Au</strong>
                                                        <w-date-picker v-model="filter.end"/>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </w-fieldset>
                                    </v-container>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>
                    <v-col :cols="module ? '12' : '10'">
                        <v-skeleton-loader
                            v-show="loading"
                            ref="skeleton"
                            :type="'table'"
                            :class="`mx-auto elevation-${tableElevation}`"
                        ></v-skeleton-loader>
                        <v-data-table
                            v-show="!loading"
                            :headers="headers"
                            :items="documentStore.documents"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="descending"
                            :server-items-length="total"
                            :loading="loading"
                            must-sort
                            :multi-sort="false"
                            hide-default-footer
                            dense
                            :class="`elevation-${tableElevation}`"
                            :item-class="rowColor"
                            @click:row="itemClick"
                            @dblclick:row="openViewDocument"
                            fixed-header
                            :height="module ? 600 : null"
                        >
                            <template v-slot:item.action="{ item }">
                                <v-menu
                                    bottom
                                    right
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            dark
                                            icon
                                            color="primary"
                                            v-on="on"
                                            @click="itemClick(item)"
                                        >
                                            <v-icon>mdi-dots-horizontal</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list nav dense>
                                        <v-list-item
                                            @click="download('documents', item.id, item.fileFullName)"
                                        >
                                            <v-list-item-icon>
                                                <v-icon v-text="'mdi-download'" color="blue"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>
                                                Télécharger
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            @click="openFormDialog(item.section, item.folder, false, true, false, item)"
                                        >
                                            <v-list-item-icon>
                                                <v-icon v-text="'mdi-pencil-box-multiple'" color="orange"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>
                                                {{ $t('common.edit') }}
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            @click="openFormDialog(item.section, item.folder, false, false, true, item)"
                                        >
                                            <v-list-item-icon>
                                                <v-icon v-text="'mdi-trash-can'" color="red"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>
                                                {{ $t('common.delete') }}
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            @click="openMoveDocument(item)"
                                        >
                                            <v-list-item-icon>
                                                <v-icon v-text="'mdi-folder-move'" color="purple"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>
                                                Déplacer
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                            <template v-slot:item.name="{ item }">
                                 <span
                                     @click="selectFolder(item.id)"
                                     v-if="item.id < 0"
                                 >
                                     <v-icon left color="amber" v-text="'mdi-folder'"/>
                                     <a><u>{{ item.name }}</u></a>
                                </span>
                                <span
                                    v-else-if="item.folder"
                                    class="drop-zone drop-valid"
                                    @dragover.prevent
                                    draggable="true"
                                    @dragstart="onDragStart(item)"
                                    @drop="onDrop(item)"
                                    @click="selectFolder(item.id)"
                                >
                                    <v-icon
                                        left
                                        :color="item.inbox ? 'red' : 'amber'"
                                        v-text="item.inbox ? 'mdi-inbox' : 'mdi-folder'"
                                    />
                                    <a style="cursor:pointer;">
                                         <v-tooltip left :disabled="!item.inbox">
                                              <template v-slot:activator="{ on, attrs }">
                                                <span
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <u>{{ item.name }}</u>
                                                </span>
                                              </template>
                                              <span>{{ item.email }}</span>
                                         </v-tooltip>
                                    </a>
                                </span>
                                <span v-else>
                                    <span
                                        class="drop-zone drop-invalid"
                                        draggable="true"
                                        @dragstart="onDragStart(item)"
                                    >

                                        <v-tooltip right>
                                          <template v-slot:activator="{ on, attrs }">
                                            <span
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-chip outlined label small>
                                                     <v-icon left v-if="item.type === 'IMAGE'" color="purple">mdi-image</v-icon>
                                                    <v-icon left v-else-if="item.type === 'PDF'" color="red">mdi-file-pdf-box</v-icon>
                                                    <v-icon left v-else-if="item.type === 'TXT'" color="cyan darken-1">mdi-text-box</v-icon>
                                                    <v-icon
                                                        v-else-if="item.type === 'ZIP' || item.type === 'RAR'"
                                                        left
                                                        color="purple"
                                                    >
                                                        mdi-folder-zip
                                                    </v-icon>
                                                    <v-icon
                                                        v-else-if="item.type === 'WORD' || item.type === 'WORD_OLD'"
                                                        left
                                                        color="blue darken-1"
                                                    >
                                                        mdi-microsoft-word
                                                    </v-icon>
                                                    <v-icon
                                                        v-else-if="item.type === 'EXCEL' || item.type === 'EXCEL_OLD'"
                                                        left
                                                        color="teal darken-1"
                                                    >
                                                        mdi-microsoft-excel
                                                    </v-icon>
                                                    <v-icon
                                                        v-else-if="item.type === 'POWER_POINT' || item.type === 'POWER_POINT_OLD'"
                                                        left
                                                        color="red darken-1"
                                                    >
                                                        mdi-microsoft-powerpoint
                                                    </v-icon>
                                                    <v-icon left v-else color="blue-grey darken-1">mdi-file</v-icon>
                                                    <strong>{{ item.name }}</strong>
                                                </v-chip>
                                            </span>
                                          </template>
                                          <span v-if="item.source === 'MANUAL'">
                                              {{ item.fileFullName }}
                                          </span>
                                            <ul v-else-if="item.source === 'EMAIL'">
                                                <li>Nom: {{ item.fileFullName }}</li>
                                                <li>From: {{ item.emailFrom }}</li>
                                                <li>Date: {{ formatedDateTime(item.receivedDate) }}</li>
                                                <li>Objet: {{ item.emailSubject }}</li>
                                            </ul>
                                        </v-tooltip>
                                    </span>
                                </span>
                            </template>
                            <template v-slot:item.number="{ item }">
                                <v-chip outlined label small v-if="item.number">
                                    <strong>
                                        {{ item.number }}
                                    </strong>
                                </v-chip>
                            </template>
                            <template v-slot:item.postDateTime="{ item }">
                                <v-chip outlined label color="teal" small>
                                    <strong>
                                        {{ formatedDate(item.postDateTime) }}
                                    </strong>
                                </v-chip>
                            </template>
                            <template v-slot:item.paths="{ item }">
                                <v-chip small outlined label @click="selectFolder(item.parentId)">
                                    <template v-for="(path, index) in item.paths">
                                        <strong :key="`path-${index}-${item.id}`">{{ path }}</strong>
                                        <v-icon
                                            v-if="index < item.paths.length - 1"
                                            :key="`path-ic-${index}-${item.id}`"
                                        >
                                            mdi-arrow-right-thin
                                        </v-icon>
                                    </template>
                                </v-chip>
                            </template>
                            <template v-slot:item.size="{ item }">
                                <v-chip
                                    v-if="item.type !== 'FOLDER'"
                                    outlined
                                    label
                                    small
                                    :class="`ma-1`"
                                >
                                    <strong>
                                        {{ (item.size / 1048576).toFixed(2) }} MB
                                    </strong>
                                </v-chip>
                            </template>

                            <template v-slot:item.ftpAction="{ item }">
                                <v-chip small class="elevation-15" label outlined>
                                    <strong>{{ $t(`common.ACTION_STATE_${item.ftpAction}`) }}</strong>
                                </v-chip>
                            </template>
                            <template v-slot:item.ocrAction="{ item }">
                                <v-chip small class="elevation-15" label outlined>
                                    <strong>{{ $t(`common.ACTION_STATE_${item.ocrAction}`) }}</strong>
                                </v-chip>
                            </template>
                            <template v-slot:footer="{}">
                                <br/>
                                <div class="text-center">
                                    <v-row justify="center">
                                        <v-col md="6">
                                            <v-pagination
                                                v-model="page"
                                                :length="Math.ceil(total / itemsPerPage)"
                                                total-visible="15"
                                                @input="findAll()"
                                            ></v-pagination>
                                        </v-col>
                                        <v-col md="2">
                                            <v-select
                                                v-model="itemsPerPage"
                                                :items="paginationListLength"
                                                :label="$t('items_per_page')"
                                                outlined
                                                dense
                                                @change="findAll"
                                                :color="inputColor"
                                                :background-color="backgroundColor"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>


        <DocumentForm
            v-if="dialog"
            :module="module"
            :parent-id="parentId"
            :dialog="dialog"
            :is-section="isSection"
            :is-folder="isFolder"
            :add-action="addAction"
            :update-action="updateAction"
            :delete-action="deleteAction"
            @close="closeFormDialog"
        />

        <DocumentView
            v-if="viewDocumentDialog"
            :dialog="viewDocumentDialog"
            @close="closeViewDocument"
        />

        <DocumentMove
            v-if="moveDialog"
            :dialog="moveDialog"
            :parent-id="parentId"
            @close="closeMoveDocument"
        />

    </div>
</template>

<script>
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {computed, onMounted, ref, watch} from "vue";
import useSharedSelectData from "@/use/SharedSelectData";
import {useDocumentStore} from "@/stores/Edms/Document";
import SectionTreeview from "@/views/Edms/Document/Components/SectionTreeview.vue";
import DocumentForm from "@/views/Edms/Document/Components/DocumentForm.vue";
import DocumentView from "@/views/Edms/Document/Components/DocumentView.vue";
import DocumentMove from "@/views/Edms/Document/Components/DocumentMove.vue";
import axios from "axios";

export default {
    name: "Documents",
    components: {DocumentMove, DocumentView, DocumentForm, SectionTreeview},
    props: {
        module: String,
    },
    setup(props) {
        const {
            dialog,
            loading,
            overlay,
            inputColor,
            backgroundColor,
            total,
            filter,
            paginationListLength,
            tableElevation,
            chipElevation,
            sortBy,
            descending,
            itemsPerPage,
            page
        } = useSharedData();
        const {documentModules} = useSharedSelectData();
        const {$route, $i18n, $refs} = useTools();
        const {getBack, download, itemClick, rowColor, formatedDateTime, formatedDate, transformFilterValues} = useSharedMethod();

        const documentStore = useDocumentStore();

        dialog.value = false;
        sortBy.value = "id";
        descending.value = true;

        const tab = ref('tab-1');

        const headers = [
            {
                text: "...",
                align: "left",
                value: "action",
                sortable: false,
                width: "0%"
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                value: "name",
                sortable: true,
            },
            {
                text: $i18n.t("common.number"),
                align: "left",
                value: "number",
                sortable: true,
            },
            {
                text: $i18n.t("common.date"),
                align: "left",
                value: "postDateTime",
                sortable: true,
            },
            {
                text: $i18n.t("common.size"),
                align: "left",
                value: "size",
                sortable: true,
            },
            {
                text: "",
                align: "left",
                value: "paths",
                sortable: false,
            },
            {
                text: "FTP",
                align: "left",
                value: "ftpAction",
                sortable: true,
            },
            {
                text: "OCR",
                align: "left",
                value: "ocrAction",
                sortable: true,
            },
            {
                text: $i18n.t("common.description"),
                align: "left",
                value: "description",
                sortable: true,
            },
        ];

        const parentId = ref(-1);
        const fullPath = ref([]);
        const loadingFullPath = ref(false);

        function getFullPath() {
            loadingFullPath.value = true;
            axios.get(`/documents/getFullPath/${parentId.value}`).then(response => {
                fullPath.value = response.data;
            }).finally(() => {
                loadingFullPath.value = false;
            });
        }

        function setDefaultParentId() {
            if (props.module) {
                documentModules.forEach(e => {
                    if (e.id === props.module) {
                        parentId.value = e.documentDatabaseId;
                    }
                });
            } else {
                parentId.value = -1;
            }
        }


        const addFolderAction = computed(() => parentId.value > 0);
        const addDocumentAction = computed(() => {
            if (props.module)
                return true;

            return parentId.value > 0;
        });

        function selectFolder(folderId) {
            if (!props.module)
                parentId.value = folderId;
        }

        function initFolder() {
            if (tab.value === "tab-1") {
                parentId.value = -1;
            } else if (tab.value === "tab-2") {
                clear();
            }
        }

        function findAll() {
            loading.value = true;

            let fil = {
                ...filter.value
            }

            if (tab.value === 'tab-1') {
                fil.moduleId = $route.params.id;
                fil.module = props.module;
                fil.uuids = null;
            } else if (tab.value === 'tab-2') {
                fil.moduleId = null;
                fil.module = null;
                fil.ids = ids.value;
                fil.uuids = uuids.value;
            }


            fil.parentId = parentId.value;
            fil.page = page.value - 1;
            fil.rowsPerPage = itemsPerPage.value;
            fil.sortBy = sortBy.value;
            fil.descending = descending.value;

            if (tab.value === 'tab-2' && uuids.value && uuids.value.length === 0) {
                documentStore.setDocuments([]);
                total.value = 0;
                loading.value = false;
            } else {
                axios.get('/documents', {params: transformFilterValues(fil)}).then((response) => {
                    documentStore.setDocuments(response.data.elements);
                    total.value = response.data.total;
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        const isSection = ref(false);
        const isFolder = ref(false);
        const addAction = ref(false);
        const updateAction = ref(false);
        const deleteAction = ref(false);

        function openFormDialog(section, folder, add, update, remove, item) {
            isSection.value = section;
            isFolder.value = folder;
            addAction.value = add;
            updateAction.value = update;
            deleteAction.value = remove;
            documentStore.setFichier(item);
            dialog.value = true;
        }

        function closeFormDialog() {
            dialog.value = false;
            isSection.value = false;
            isFolder.value = false;
            addAction.value = false;
            updateAction.value = false;
            deleteAction.value = false;
            documentStore.setFichier({});
        }

        const viewDocumentDialog = ref(false);

        function openViewDocument(event, {item}) {
            documentStore.setFichier(item);
            viewDocumentDialog.value = true;

        }

        function closeViewDocument() {
            viewDocumentDialog.value = false;
            documentStore.setFichier({});
        }

        const moveDialog = ref(false);

        function openMoveDocument(item) {
            documentStore.setFichier(item);
            moveDialog.value = true;
            $refs.documentMove.findAll();

        }

        function closeMoveDocument() {
            moveDialog.value = false;
            documentStore.setFichier({});
        }


        watch([sortBy, descending], () => {
            findAll();
        });

        watch(() => filter.value, () => {
            page.value = 1;
            findAll();
        }, {deep: true});

        watch(() => parentId.value, () => {
            page.value = 1;
            if (parentId.value) {
                findAll();
                getFullPath();
            }
        });

        let savedParentId = ref(null);
        watch(() => tab.value, () => {
            page.value = 1;
            if (tab.value === "tab-1") {
                parentId.value = savedParentId.value;
            } else if (tab.value === "tab-2") {
                savedParentId.value = parentId.value;
                parentId.value = null;
            }
            findAll();
        });

        onMounted(() => {
            setDefaultParentId();
            findAll();
        });


        const selectedDraggedItem = ref(null);

        function onDragStart(item) {
            selectedDraggedItem.value = item;
        }


        function onDrop(destination) {
            if (selectedDraggedItem.value.id !== destination.id) {
                // loading.value = true;
                let url = `/documents/move/${selectedDraggedItem.value.id}/to/${destination.id}`;
                axios.put(url).then(response => {
                    documentStore.moveDocument(response.data.movedFrom, destination.id, response.data);
                    selectedDraggedItem.value = null;
                }).finally(() => {
                    // loading.value = false;
                });
            }
        }

        const search = ref(null);
        const ids = ref(null);
        const uuids = ref(null);

        function getSemanticSearch() {
            parentId.value = null;
            axios.get('/documents/semanticSearch', {params: {searchText: search.value}}).then(response => {
                // ids.value = response.data;
                uuids.value = response.data;
                findAll();
            });
        }

        function clear() {
            $refs.searchForm.reset();
            ids.value = null;
            uuids.value = null;
            fullPath.value = [];
            parentId.value = null;
            findAll();
        }

        return {
            search,
            tab,
            documentStore,
            addFolderAction,
            addDocumentAction,
            dialog,
            loading,
            overlay,
            inputColor,
            backgroundColor,
            paginationListLength,
            tableElevation,
            chipElevation,
            sortBy,
            descending,
            total,
            itemsPerPage,
            page,
            headers,
            parentId,
            fullPath,
            isSection,
            isFolder,
            addAction,
            updateAction,
            deleteAction,
            filter,
            onDrop,
            onDragStart,
            formatedDateTime,
            formatedDate,
            selectFolder,
            initFolder,
            findAll,
            openFormDialog,
            closeFormDialog,
            getBack,
            download,
            itemClick,
            rowColor,
            viewDocumentDialog,
            openViewDocument,
            closeViewDocument,
            moveDialog,
            openMoveDocument,
            closeMoveDocument,
            getSemanticSearch,
            clear

        }
    },
}
</script>

<style>
.drop-zone {
    padding: 4px;
    border: 1px dashed transparent;
}

.drop-zone:hover {
    border: 1px dashed #1976d2;
    background-color: #e3f2fd;
    cursor: pointer;
}
</style>